module.exports = __webpack_public_path__ + "img/pv.b080a1fc.png";